import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/auth';
import { Container, Profile } from './styles';

import ComboBox from './ComboBox';
import { useToast } from '../../hooks/toast';
import api from '../../services/api';
import { ComboBoxContext } from '../../contexts/ComboBoxContext';

interface Empresa {
  cd: string;
  nm: string;
  hash: string;
  cd_empresa: string;
}

const Header = () => {
  const { cdEmpresa, setCdEmpresa, empresa, setEmpresa } =
    useContext(ComboBoxContext);
  const [visivel, setVisivel] = useState('hidden');
  const { user, contrato } = useAuth();

  const location = useLocation();
  location.pathname;

  const { addToast } = useToast();

  const populaTabela = useCallback(() => {
    api
      .get<Empresa[]>('empresas')
      .then((response) => {
        setEmpresa(response.data);
      })
      .catch((error) => {
        addToast({
          type: 'error',
          title: 'Erro',
          description: `Ops, ocorreu um erro ao listar as empresa: ${error}`,
        });
      });
  }, [addToast, setEmpresa]);

  /* useEffect(() => {
    if (location.pathname == '/dashboard') {
      setVisivel('visible');
    }
  }, [visivel, location]); */

  useEffect(() => {
    populaTabela();
  }, [populaTabela]);
  return (
    <Container>
      <Profile>
        <span>
          Bem-vindo,{' '}
          <strong>
            {user.nm_razao} - {contrato}
          </strong>
        </span>
        <ComboBoxContext.Provider
          value={{ cdEmpresa, setCdEmpresa, empresa, setEmpresa }}
        >
          <ComboBox /* style={{ visibility: `${visivel}` as string }} */ />
        </ComboBoxContext.Provider>
      </Profile>
    </Container>
  );
};

export default Header;
